import { useTheme } from '../context/ThemeContext';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  return (
    <button
      className="btn btn-ghost btn-sm"
      onClick={toggleTheme}
      title={theme === 'light' ? 'Ativar tema escuro' : 'Ativar tema claro'}
      aria-label={theme === 'light' ? 'Ativar tema escuro' : 'Ativar tema claro'}
    >
      {theme === 'light' ? '🌙' : '☀️'}
    </button>
  );
}
